// extracted by mini-css-extract-plugin
module.exports = {"container":"ContentContainer_container__s7dX2"};